<!-- No Calculated CD, No Formula CD -->
<ng-container
  *ngIf="!subprojectConfiguration.enableCalculatedCustomData && !subprojectConfiguration.enableCustomDataFormula"
>
  <app-report-activities-basic
    *ngIf="inlineCustomDataLength === 0"
    [activityModel]="activityModel"
  ></app-report-activities-basic>

  <app-report-activities-with-inline-cd
    *ngIf="inlineCustomDataLength > 0"
    [activityModel]="activityModel"
  ></app-report-activities-with-inline-cd>
</ng-container>

<!-- With Calculated CD and/or Formula CD -->
<ng-container
  *ngIf="subprojectConfiguration.enableCalculatedCustomData || subprojectConfiguration.enableCustomDataFormula"
>
  <app-report-activities-with-calculated-and-or-formula-cd
    *ngIf="inlineCustomDataLength === 0"
    [activityModel]="activityModel"
    [calculatedCustomDataName]="subprojectConfiguration.calculatedCustomDataConfiguration?.name"
    [customDataFormulaName]="subprojectConfiguration.customDataFormulaConfiguration?.name"
    [subprojectConfiguration]="subprojectConfiguration"
  ></app-report-activities-with-calculated-and-or-formula-cd>

  <app-report-activities-with-calculated-and-or-formula-and-inline-cd
    *ngIf="inlineCustomDataLength > 0"
    [activityModel]="activityModel"
    [calculatedCustomDataName]="subprojectConfiguration.calculatedCustomDataConfiguration?.name"
    [customDataFormulaName]="subprojectConfiguration.customDataFormulaConfiguration?.name"
    [subprojectConfiguration]="subprojectConfiguration"
  ></app-report-activities-with-calculated-and-or-formula-and-inline-cd>
</ng-container>
